import axios, { axiosNT, axiosNTL, axiosNL, axiosNS, axiosUpload } from '../../../services/axios';
import { buildSKUString,flattenMainTests,getRequestId,getStatusType, transformMainTests } from '../helpers/helpers';
import { CourseBasicDetails } from '../types/interfaces/CourseBasicDetails';
import { ResponseData } from './interface';
import _, { isArray } from "lodash";
import moment from 'moment';
import { getQueryParams } from '../../../utils';
import ACLService from '../../acl/services/aclService';

const getPackageById = async (id: string) => {
    const requestId = getRequestId();
    let res={};
    if (requestId) {
        const data = await getPackageByRequestId(requestId);
        res = { responseObject: { packageData: data.responseObject.requestedPackageDetails.package } };
    } else {
        res = await axiosNT.get(`package/v4/${id}`);
    }
    return Promise.resolve<any>(res);
}

const getPackageByRequestId = (id: string) => axiosNT.get(`/package/v4/requests/${id}`).then((response: any) => {
    return Promise.resolve(response);
});

const getPackageTemplates = (queryData: any) => axiosNT.get(`package/v4/package-templates`, {
    params: {
        ...queryData
    }
}).then((response: any) => {
    return Promise.resolve(response);
})

const getCousePlanApiById = async (id: string, isUser?: boolean) => {
    const requestId = getRequestId();
    let res: any={};
    if (requestId) {
        const data = await getPackageByRequestId(requestId);
        res = { responseObject: { coursePlan: data.responseObject.requestedCoursePlan.coursePlan }  };
    } else {
        let apiUrl = `course-plan/${id}`;
        const userId = await ACLService.getUserDetailsFromStorage().authenticatedUser._id;
        if (isUser) {
            apiUrl += `/${userId}`;
        }
        res = await axiosNT.get(apiUrl);
    }
    res = { coursePlan: flattenMainTests(res.responseObject.coursePlan), requests: res.responseObject.requests };
    return Promise.resolve<any>(res);
};

  const updateCousePlanApiById = (data:any) => {
   
    return axiosNS
      .put(`course-plan`,data)
      .then((res: any) => {
        return Promise.resolve(res);
      });
  };

const updatePackageBasicDetailsById=(payload:any)=>{
  const{packageId,data}=payload;
  return axiosNS.put(`/package/v4/${packageId}/basic-settings`,data).then((res: any) => {
    return Promise.resolve(res);
  });
}

// const contentManagementService = { getPackageById, getPackageTemplates, getCousePlanApiById ,updateCousePlanApiById};
const addCourseBasicDetails = (courseBasicDetails:CourseBasicDetails) : any => {
    // const updatedCourseBasicDetails = {
    //     ...courseBasicDetails, 
    //     sku: buildSKUString(courseBasicDetails.sku)
    // }

    return axiosNTL.post(
        '/package/v4',
        courseBasicDetails
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const getBulkReport = (pageNumber:any) : any => {
    return axiosNT.get(
        `/bulk-operation/report?pageNumber=${pageNumber}`
    ).then((res: any) => {
        return Promise.resolve(res.responseObject)
    })
}



const updateCourseBasicDetails = (payload:any) => {
  const { courseBasicDetails, packageId } = payload
  return axiosNS.put(
    `/package/v4/${packageId}/basic-settings`,
    courseBasicDetails
  ).then((res: any) => {
    return Promise.resolve(res);
  })
}

const createPackage = (data: any) => {
    let dataToPass = JSON.parse(JSON.stringify(data));
    dataToPass.startDate = moment(dataToPass.startDate).utcOffset('+0530').startOf('day').toISOString();
    dataToPass.expiryDate = moment(dataToPass.expiryDate).utcOffset('+0530').endOf('day').toISOString();
  return axiosNTL.post('/package/v4', dataToPass).then((res: any) => {
    return Promise.resolve(res);
  });
};

const getActiveGoals = () => {
    return axiosNT.get(
        '/course/active-goals'
    ).then((res: any) => {
        return Promise.resolve(res.responseObject.goals)
    })
}
  const getGoalLevel = (courseTypeId: any) => axiosNT.get(`/goal-level`, {
        params: {
            courseTypeId
        }
    }).then((response: any) => {
        return Promise.resolve(response.responseObject);
    })


const getActiveCourses = () => {
    return axiosNT.get(
        'package/v4?pagination=false&statusType=master&statusValue=LIVE,PUBLISHED'
    ).then((res: any) => {
        return Promise.resolve(res.responseObject.packages)
    })
}

const updateVersion =(payload:any)=>{
return axiosNT.post('package/v4',payload).then((res:any)=>{
    if(res.statusCode !== 200) {
        return Promise.reject("Failed")
    }
    return Promise.resolve(res.responseObject)
})
}

const getUserSuggestions = (payload: any) => {
    let clientId = payload.clientId;
    if(!isArray(clientId)){
        clientId=[clientId];
    }
    return axiosNT.post(
        '/user/filtered-users',
        {
            // params: {
                "modules": [
                    {
                        "name": "course",
                        "permissions": [
                            "edit"
                        ]
                    }
                ],
                "clientIds": clientId
            // }
        }
    ).then((res: any) => {
        return Promise.resolve(res.responseObject.users)
    })
}

const getCourseSyllabus = async (courseId: any) => {
    let endpoint = `courseSyllabus/getAllCourseSyllabus/${courseId}?partial=true`;
    return await axiosNT.get(endpoint)
        .then((res: any) => {
            let resultObjt: any = res.responseObject || {};
            return Promise.resolve(resultObjt);
        }).catch((error) => {
            return Promise.reject(error);
        })
};

const getCourseDetail = async (courseId: any) => {
	let endpoint = `course/getCourse/${courseId}`;
    return await axiosNT.get(endpoint)
    .then((res: any) => {
        let resultObjt: any = res.responseObject || {};
        return Promise.resolve(resultObjt);
    }).catch((error) => {
        return Promise.reject(error);
    })
};

const createCoursePlan = async (payLoadData: any) => {
	let endpoint = `course-plan`;
    return await axiosNT.post(
        endpoint,
        transformMainTests(payLoadData)
    ).then((res: any) => {
     //   let resultObjt: any = res.responseObject || {};
        return Promise.resolve(res);
    }).catch((error) => {
        return Promise.reject(error);
    })
};

const saveAdvancedSettings = (payload: any) => {
    const { packageId, advancedSettings, packageChangeRequestId } = payload;
    const advancedSettingsPayload = {
        ...advancedSettings,
        packageChangeRequestId
    };
    return axiosNS.put(
        `/package/v4/${packageId}/advance-settings`,
        advancedSettingsPayload
    ).then((res: any) => {
        return Promise.resolve(res.statusCode)
    })
}

const getCourseData = async (payload: any) => {
    const data = await getPackageById(payload);
    return Promise.resolve(data.responseObject.packageData);
}

const fetchExistingScheduledTests = (id: any) => {

    return axiosNT.get(
        `/course-plan/schedule-test/${id}`
    ).then((res:any) => {
        return Promise.resolve(res.responseObject.scheduledTests)
    })

}


const fetchScheduleTests=(params:any)=>{
    const {itemType,id, testType='phase'}=params;
      return axiosNT.get(
        `/course-item/${itemType}/${id}?testType=${testType}`
    ).then((res:any) => {
        return Promise.resolve(res.responseObject.tests)
    })
}
const getScheduleTestsForMapping=(payload:any)=>{
    const {params,queryParams}=payload;
    const {itemType,id, testType='phase'}=params;
    let api=`/course-item/${itemType}/${id}`;
    
    let paramsTxt=`?testType=${testType}`;
    if(queryParams){
     const keys=Object.keys(queryParams);
     if(keys){
        paramsTxt= keys.reduce((acc,key,index)=>{  
           acc=acc+key+'='+queryParams[key]+'&';
          return acc; 
         },'?');
      }
    }
      return axiosNT.get(api+paramsTxt).then((res:any) => {
        return Promise.resolve(res.responseObject.tests)
    })
}
const validateMapTestIdBySource=({contentId,courseId,source}:any)=>{
    try{ 
        return axiosNTL.get(
             `/course-item/validate-test/${contentId}/course/${courseId}?source=${source}`
         ).then((res:any) => {
             const{responseObject,statusCode,responseMessage}=res;
             let error='';
             if(statusCode==422){
                error=responseMessage;
             }
             return error;
         })
    }catch(err){
       console.log("Error in CourseManagement Service",err);
   }
 }
const validateMapTestId=({testContentId,courseId}:any)=>{
   try{ 
       return axiosNTL.get(
            `/course-item/validate-test/${testContentId}/course/${courseId}`
        ).then((res:any) => {
            const{responseObject,statusCode,responseMessage}=res;
            const test=_.get(responseObject,"test",{});
            const newRes:any={test};
            if(statusCode==422){
              newRes.error=responseMessage
            }
            return Promise.resolve(newRes);
        })
  }catch(err){
      console.log("Error in CourseManagement Service",err);
  }
}

const fetchCourseDataListWithScheduleId=(payload :any)=>{
    return axiosNT.post(
        `/course-plan/tests-packages`,
        payload
    ).then((res:any) => {
        
        return Promise.resolve(res.responseObject)
    })
 }

 const mapScheduledTests=(payload :any)=>{
    return axiosNT.post(
        `/course-plan/map-schedule-tests`,
        payload
    ).then((res:any) => {
        return Promise.resolve(res.statusCode)
    })
 }

const getBasicInfo = (payload: string) => {
  return axiosNT.get(
    `/package/v4/${payload}`
  ).then((res:any) => {

    return Promise.resolve(res.responseObject.packageData)
  })
}

const fetchCoursesByScheduleId = (payload: any) => {
  return axiosNTL.get(`/course-plan/schedule-id-usage?scheduleId=${payload}`).then((res: any) => {
    return Promise.resolve(res.responseObject.scheduleIdMap); // Update to res.responseObject
  });
};

const fetchMapTestSuggestions = (payload: any) => {
   
    let payloadData = {
        classes: "",
        contentMenu: "all",
        contentSubTypeCode: payload.testType,
        contentTypeCode: "testpapers",
        courses: "",
        createdBy: "",
        difficulty: "",
        publishedBy: "",
        searchText: payload && payload.searchText ? payload.searchText : payload,
        skills: "",
        status: "PUBLISHED,",
        tags: "",
        goalsDriller: payload.goalsDriller
    }
    // payloadData = {
    //     ...payloadData,
    //     searchText: searchText
    // }
    return axiosNT.post(
        `/content/getContentList?page=1&limit=20`,
        payloadData
    ).then((res:any) => {
        return Promise.resolve(res.responseObject)
    })
}


const updateCoursePlan = (coursePlan: any, revisedHours?: any, phaseUploadUrl?: any, proceedUpload?: boolean) => {
    const { packageChangeRequestId, packageId } = coursePlan;
    coursePlan = handleHoursAllocationUpdation(coursePlan, revisedHours);
    coursePlan = updatePhaseFileUrl(coursePlan, phaseUploadUrl);
    let coursePlanPayload = {
        ...transformMainTests(coursePlan),
        packageId
    };
    proceedUpload && (coursePlanPayload.proceedUpload = proceedUpload);
    return axiosNS.put(`/course-plan`,
        coursePlanPayload
    ).then((response: any) => {
          return Promise.resolve(response)
    })
    .catch((err)=>{
        console.log({err});
    });
};

const handleHoursAllocationUpdation = (data: any, revisedHours: any) => {
    if (Object.keys(revisedHours || {}).length) {
        Object.keys(revisedHours || {}).forEach((key: any) => {
            const revisedPhase = revisedHours[key];
            const phase = data.phases.find((p: any) => p._id === key);
            if (phase) {
                let totalPhaseHours = 0;
                phase.weeks.forEach((week: any) => {
                    let totalWeekHours = 0;
                    week.subjects.forEach((subject: any) => {
                        let totalHours = 0;
                        subject.chapters.forEach((chapter: any) => {
                            const matchingRevisedChapter = revisedPhase.chaptersListing.find((chap: any) => chap.id === chapter.id);
                            if (matchingRevisedChapter) {
                                chapter.hours = +matchingRevisedChapter.hours;
                                totalHours += +matchingRevisedChapter.hours;
                            }
                        });
                        subject.hours = totalHours;
                        totalWeekHours += totalHours;
                    });
                    week.hours = totalWeekHours;
                    totalPhaseHours += totalWeekHours;
                });
                phase.hours = totalPhaseHours;
            }
        });
    }
    return data;
};

const updatePhaseFileUrl = (data: any, phaseUploadUrl: any) => {
    Object.keys(phaseUploadUrl || {}).forEach((item: any) => {
        const phase = data.phases.find((p: any) => p._id === phaseUploadUrl[item].phase);
        phase.phasePlanFileUrl = phaseUploadUrl[item].url;
    })
    return data;
}


const getCourseDetails = (courseId: string) =>
    axiosNT.get(`/course/getCourse/${courseId}`).then((res: any) =>
        Promise.resolve(res.responseObject)
    )

// const getCourseAPI = () => {
//         const id = '5ace202e9fe7b01d5806bb69';
//         return axios
//           .get(`course/getCourse/${id}`)
//           .then((res: any) => {
//             return Promise.resolve(res.responseObject);
//           });
// };
    
const getAllSubjects = () => axiosNT(`/subject`).then((res: any) => Promise.resolve(res.responseObject));

const validateTestIds = (reqParams: any) => {
  return axiosNT.post(`/test/validate-mapping`, reqParams).then((res: any) => {
    return Promise.resolve(res.responseObject);
  });
};
const getTestSuggestions = (payload: any) => {
    const { searchText,course, testType, goalsDriller, showAllBucketContent} = payload;
    
    let payloadData: any = {
        classes: "",
        contentMenu: "all",
        contentSubTypeCode: testType,
        contentTypeCode: "testpapers",
        courses: "",
        createdBy: "",
        difficulty: "",
        publishedBy: "",
        searchText: searchText,
        skills: "",
        status: "PUBLISHED,",
        tags: "",
        goalsDriller: goalsDriller
    }
    if (showAllBucketContent) {
        payloadData.showAllBucketContent = true;
    }
    return axiosNTL.post(
        `/content/getContentList?page=1&limit=20`,
        payloadData
    ).then((res:any) => {
        return Promise.resolve(res.responseObject)
    })
}

const publishCourse = (payload: any) => {
  const reqBody = payload
  return axios.put(
    `/package/v4/publish`,
    reqBody
  ).then((res:any) => {
    return Promise.resolve(res)
  })
}

const approveCourse = (requestId: any) => {
    return axios.put(
        `/package/v4/requests/${requestId}/approve`
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const rejectCourse = (rejectDetails: any) => {
    const { requestId, remark } = rejectDetails;
    return axios.put(
        `/package/v4/requests/${requestId}/reject`,
        { rejectionRemark: remark }
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const closeCourse = (rejectDetails: any) => {
    const { requestId, remark } = rejectDetails;
    return axios.put(
        `/package/v4/requests/${requestId}/close`,
        { closeRemark: remark }
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const getHistory = (requestId: string) => {
    return axiosNT.get(
        `/course-plan/course-plan-history/${requestId}`,
    ).then((res: any) => {
        if (res && res.statusCode === 200) {
            return Promise.resolve(res.responseObject);
        } else {
            Promise.reject(res.responseObject);
        }
    })
}

const updateCoursePlanAndProceed = (payload: any) => {
    return axiosNT.post(
        `course-plan/confirm/request`,
        payload,
    )
}

const getBulkExamDates = (ids: any) => {
    return axiosNTL.get(`/course/exam-dates?courseIds=${ids}`)
    .then((res:any)=> Promise.resolve(res));
}

const getPublishProcessStatus = (coursePlanId: string) => {
    return axiosNTL.get(`/course-plan/${coursePlanId}/publish-process/status`).then((res: any) => {
        return Promise.resolve(res.responseObject)
    })
}

const createDuplicatePackage = (data:{packageId:String}) : any => {

    return axiosNTL.post(
        '/package/v4/duplicate',
        data
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const addBlukContent =(payload:any):any=>{
    return axiosNTL.post(
        '/course-plan/upload-bulk-content',
        payload
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const getContentFromPackages=(payload:any):Promise<any []>=>{
    return axiosNTL.post(
        '/course-plan/fetch-content',
        payload
    ).then((res: any) => {
        const contents=_.get(res,"responseObject.content",[]);
        return Promise.resolve(contents);
    }); 
}
const updateBulkContent=(payload:any):any=>{
    return axiosNTL.put(
        '/course-plan/bulk-content',
        payload
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const mapBulkSyllabus = (payload : any):any=>{
    return axiosNTL.post(
        '/unmapped-tests/syllabus',
        payload
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const deleteBulkContent=(payload:any):any=>{
     return axiosNTL.delete(
        '/course-plan/bulk-content',
        {data:payload}
    ).then((res: any) => {
        return Promise.resolve(res);
    });
}

const getCourseHistory = (requestId: string): any => {
    return axios.get(
        `/course-plan/course-plan-changes/${requestId}`,
    ).then((res: any) => {
        if (res && res.statusCode === 200) {
            return Promise.resolve(res.responseObject);
        } else {
            Promise.reject(res.responseObject);
        }
    });
}
const preSignedURL = async (params: any) => {
    return axiosNTL.get('aws/phasePlan', { params })
        .then((res: any) => {
            const { aws }: { aws: any } = res.responseObject || {};
            return Promise.resolve(aws);
        });
}

const uploadPhasePlanOnS3 = async (params: any) => {
    try {
        const awsObject: any = await preSignedURL({contentType: params.contentType});
        if (awsObject && awsObject.signedUrl) {
            await axiosUpload.put(`${awsObject.signedUrl}`, params.file, {
                headers: {
                    "Content-Type": params.file.type,
                }
            });
            return awsObject.signedUrl;
        }
    } catch (error) {
        return Promise.reject(error);
    }
}

const contentManagementService = {
    updateBulkContent,
    deleteBulkContent,
    getPackageById,
    getPackageTemplates,
    getCousePlanApiById,
    addCourseBasicDetails,
    getBulkReport,
    updateCourseBasicDetails,
    getActiveGoals,
    getGoalLevel,
    updateVersion,
    getActiveCourses,
    getUserSuggestions,
    getCourseSyllabus,
    saveAdvancedSettings,
    getCourseDetail,
    createCoursePlan,
    addBlukContent,
    updateCousePlanApiById,
    getCourseDetails,
    getAllSubjects,
    updateCoursePlan,
    fetchExistingScheduledTests,
    fetchMapTestSuggestions,
    getCoursePlanById: getCousePlanApiById,
    validateTestIds,
    fetchCoursesByScheduleId,
    createPackage,
    fetchScheduleTests,
    getTestSuggestions,
    updatePackageBasicDetailsById,
    getBasicInfo: getCourseData,
    getCourseData,
    publishCourse,
    getBulkExamDates,
    getPublishProcessStatus,
    createDuplicatePackage,
    getScheduleTestsForMapping,
    validateMapTestId,
    fetchCourseDataListWithScheduleId,
    mapScheduledTests,
    getContentFromPackages,
    mapBulkSyllabus,
    validateMapTestIdBySource,
    getPackageByRequestId,
    approveCourse,
    rejectCourse,
    closeCourse,
    getHistory,
    updateCoursePlanAndProceed,
    getCourseHistory,
    uploadPhasePlanOnS3
};
export default contentManagementService;
